import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-help",
  "use": "icon-help-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-help\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8 14.667A6.667 6.667 0 1 0 8 1.333a6.667 6.667 0 0 0 0 13.334Zm.666-10.334a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM8 8H6.666V6.667H8c.736 0 1.333.597 1.333 1.333v4H8V8Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol